import { getName as getCountryName } from 'country-list'
import { isNil } from 'lodash'

import { Location } from './location.types'

export function getLocationName(location: Partial<Location>) {
  const { city, region, countryCode = '', fullAddress, continent } = location
  if (continent) {
    return continent
  }
  if (isNil(city) && isNil(region) && isNil(countryCode)) {
    return fullAddress
  }

  let countryByCode = getCountryName(countryCode)
  if (!countryByCode && countries3DMap.has(countryCode)) {
    countryByCode = countries3DMap.get(countryCode)
  }

  if (city || region) {
    const countryByCodeString = countryByCode ? `(${countryByCode})` : ''
    return `${city || region} ${countryByCodeString}`.trim()
  }

  return countryByCode
}

export const countries3DMap = new Map<string, string>(
  Object.entries({
    AFG: 'Afghanistan',
    ALA: 'Åland Islands',
    ALB: 'Albania',
    DZA: 'Algeria',
    ASM: 'American Samoa',
    AND: 'Andorra',
    AGO: 'Angola',
    AIA: 'Anguilla',
    ATA: 'Antarctica',
    ATG: 'Antigua & Barbuda',
    ARG: 'Argentina',
    ARM: 'Armenia',
    AUS: 'Australia',
    AUT: 'Austria',
    AZE: 'Azerbaijan',
    BHS: 'Bahamas',
    BHR: 'Bahrain',
    BGD: 'Bangladesh',
    BRB: 'Barbados',
    BLR: 'Belarus',
    BEL: 'Belgium',
    BLZ: 'Belize',
    BEN: 'Benin',
    BMU: 'Bermuda',
    BTN: 'Bhutan',
    BOL: 'Bolivia',
    BIH: 'Bosnia',
    BWA: 'Botswana',
    BVT: 'Bouvet Island',
    BRA: 'Brazil',
    IOT: 'British Indian Ocean Territory',
    VGB: 'British Virgin Islands',
    BRN: 'Brunei',
    BGR: 'Bulgaria',
    BFA: 'Burkina Faso',
    BDI: 'Burundi',
    KHM: 'Cambodia',
    CMR: 'Cameroon',
    CAN: 'Canada',
    CPV: 'Cape Verde',
    BES: 'Caribbean Netherlands',
    CYM: 'Cayman Islands',
    CAF: 'Central African Republic',
    TCD: 'Chad',
    CHL: 'Chile',
    CHN: 'China',
    CXR: 'Christmas Island',
    CCK: 'Cocos (Keeling) Islands',
    COL: 'Colombia',
    COM: 'Comoros',
    COG: 'Congo - Brazzaville',
    COD: 'Congo - Kinshasa',
    COK: 'Cook Islands',
    CRI: 'Costa Rica',
    CIV: 'Côte d’Ivoire',
    HRV: 'Croatia',
    CUB: 'Cuba',
    CUW: 'Curaçao',
    CYP: 'Cyprus',
    CZE: 'Czechia',
    DNK: 'Denmark',
    DJI: 'Djibouti',
    DMA: 'Dominica',
    DOM: 'Dominican Republic',
    ECU: 'Ecuador',
    EGY: 'Egypt',
    SLV: 'El Salvador',
    GNQ: 'Equatorial Guinea',
    ERI: 'Eritrea',
    EST: 'Estonia',
    SWZ: 'Eswatini',
    ETH: 'Ethiopia',
    FLK: 'Falkland Islands',
    FRO: 'Faroe Islands',
    FJI: 'Fiji',
    FIN: 'Finland',
    FRA: 'France',
    GUF: 'French Guiana',
    PYF: 'French Polynesia',
    ATF: 'French Southern Territories',
    GAB: 'Gabon',
    GMB: 'Gambia',
    GEO: 'Georgia',
    DEU: 'Germany',
    GHA: 'Ghana',
    GIB: 'Gibraltar',
    GRC: 'Greece',
    GRL: 'Greenland',
    GRD: 'Grenada',
    GLP: 'Guadeloupe',
    GUM: 'Guam',
    GTM: 'Guatemala',
    GGY: 'Guernsey',
    GIN: 'Guinea',
    GNB: 'Guinea-Bissau',
    GUY: 'Guyana',
    HTI: 'Haiti',
    HMD: 'Heard & McDonald Islands',
    HND: 'Honduras',
    HKG: 'Hong Kong',
    HUN: 'Hungary',
    ISL: 'Iceland',
    IND: 'India',
    IDN: 'Indonesia',
    IRN: 'Iran',
    IRQ: 'Iraq',
    IRL: 'Ireland',
    IMN: 'Isle of Man',
    ISR: 'Israel',
    ITA: 'Italy',
    JAM: 'Jamaica',
    JPN: 'Japan',
    JEY: 'Jersey',
    JOR: 'Jordan',
    KAZ: 'Kazakhstan',
    KEN: 'Kenya',
    KIR: 'Kiribati',
    KWT: 'Kuwait',
    KGZ: 'Kyrgyzstan',
    LAO: 'Laos',
    LVA: 'Latvia',
    LBN: 'Lebanon',
    LSO: 'Lesotho',
    LBR: 'Liberia',
    LBY: 'Libya',
    LIE: 'Liechtenstein',
    LTU: 'Lithuania',
    LUX: 'Luxembourg',
    MAC: 'Macau',
    MDG: 'Madagascar',
    MWI: 'Malawi',
    MYS: 'Malaysia',
    MDV: 'Maldives',
    MLI: 'Mali',
    MLT: 'Malta',
    MHL: 'Marshall Islands',
    MTQ: 'Martinique',
    MRT: 'Mauritania',
    MUS: 'Mauritius',
    MYT: 'Mayotte',
    MEX: 'Mexico',
    FSM: 'Micronesia',
    MDA: 'Moldova',
    MCO: 'Monaco',
    MNG: 'Mongolia',
    MNE: 'Montenegro',
    MSR: 'Montserrat',
    MAR: 'Morocco',
    MOZ: 'Mozambique',
    MMR: 'Myanmar',
    NAM: 'Namibia',
    NRU: 'Nauru',
    NPL: 'Nepal',
    NLD: 'Netherlands',
    NCL: 'New Caledonia',
    NZL: 'New Zealand',
    NIC: 'Nicaragua',
    NER: 'Niger',
    NGA: 'Nigeria',
    NIU: 'Niue',
    NFK: 'Norfolk Island',
    PRK: 'North Korea',
    MKD: 'North Macedonia',
    MNP: 'Northern Mariana Islands',
    NOR: 'Norway',
    OMN: 'Oman',
    PAK: 'Pakistan',
    PLW: 'Palau',
    PSE: 'Palestine',
    PAN: 'Panama',
    PNG: 'Papua New Guinea',
    PRY: 'Paraguay',
    PER: 'Peru',
    PHL: 'Philippines',
    PCN: 'Pitcairn Islands',
    POL: 'Poland',
    PRT: 'Portugal',
    PRI: 'Puerto Rico',
    QAT: 'Qatar',
    REU: 'Réunion',
    ROU: 'Romania',
    RUS: 'Russia',
    RWA: 'Rwanda',
    WSM: 'Samoa',
    SMR: 'San Marino',
    STP: 'São Tomé & Príncipe',
    SAU: 'Saudi Arabia',
    SEN: 'Senegal',
    SRB: 'Serbia',
    SYC: 'Seychelles',
    SLE: 'Sierra Leone',
    SGP: 'Singapore',
    SXM: 'Sint Maarten',
    SVK: 'Slovakia',
    SVN: 'Slovenia',
    SLB: 'Solomon Islands',
    SOM: 'Somalia',
    ZAF: 'South Africa',
    SGS: 'South Georgia & South Sandwich Islands',
    KOR: 'South Korea',
    SSD: 'South Sudan',
    ESP: 'Spain',
    LKA: 'Sri Lanka',
    BLM: 'St. Barthélemy',
    SHN: 'St. Helena',
    KNA: 'St. Kitts & Nevis',
    LCA: 'St. Lucia',
    MAF: 'St. Martin',
    SPM: 'St. Pierre & Miquelon',
    VCT: 'St. Vincent & Grenadines',
    SDN: 'Sudan',
    SUR: 'Suriname',
    SJM: 'Svalbard & Jan Mayen',
    SWE: 'Sweden',
    CHE: 'Switzerland',
    SYR: 'Syria',
    TWN: 'Taiwan',
    TJK: 'Tajikistan',
    TZA: 'Tanzania',
    THA: 'Thailand',
    TLS: 'Timor-Leste',
    TGO: 'Togo',
    TKL: 'Tokelau',
    TON: 'Tonga',
    TTO: 'Trinidad & Tobago',
    TUN: 'Tunisia',
    TUR: 'Turkey',
    TKM: 'Turkmenistan',
    TCA: 'Turks & Caicos Islands',
    TUV: 'Tuvalu',
    UMI: 'U.S. Outlying Islands',
    VIR: 'U.S. Virgin Islands',
    UGA: 'Uganda',
    GBR: 'United Kingdom',
    UKR: 'Ukraine',
    ARE: 'United Arab Emirates',
    URY: 'Uruguay',
    USA: 'United States',
    UZB: 'Uzbekistan',
    VUT: 'Vanuatu',
    VAT: 'Vatican City',
    VEN: 'Venezuela',
    VNM: 'Vietnam',
    WLF: 'Wallis & Futuna',
    ESH: 'Western Sahara',
    YEM: 'Yemen',
    ZMB: 'Zambia',
    ZWE: 'Zimbabwe',
  })
)

// EU	Europe
// AF	Africa
// NA	North America
// SA	South America
// AS	Asia
// OC	Oceania
const continentsMap = new Map<string, string>()
continentsMap.set('EU', 'Europe')
continentsMap.set('NA-SA', 'Americas')
continentsMap.set('AS-OC', 'Asia Pacific')
continentsMap.set('AS-AF', 'Middle East/Africa')

export const continentCountryMap = new Map<string, string>()
continentCountryMap.set(
  'EU',
  'ALA,ALB,AND,AUT,BLR,BEL,BIH,BGR,HRV,CZE,DNK,EST,FRO,FIN,FRA,DEU,GIB,GRC,GGY,VAT,HUN,ISL,IRL,IMN,ITA,JEY,LVA,LIE,LTU,LUX,MLT,MDA,MCO,MNE,NLD,MKD,NOR,POL,PRT,ROU,RUS,SMR,SRB,SVK,SVN,ESP,SJM,SWE,CHE,UKR,GBR'
)
continentCountryMap.set(
  'NA-SA',
  'ATG,BHS,BRB,BMU,BLZ,VGB,CAN,CYM,CRI,CUB,DMA,DOM,SLV,GRL,GRD,GLP,GTM,HTI,HND,JAM,MTQ,MEX,MSR,ANT,CUW,ABW,SXM,BES,NIC,UMI,PAN,PRI,BLM,KNA,AIA,LCA,MAF,SPM,VCT,TTO,TCA,USA,VIR'
)
continentCountryMap.set(
  'AS-OC',
  'AFG,ARE,ARM,AZE,BGD,BHR,BRN,BTN,CHN,CYP,GEO,IND,IDN,IRN,IRQ,ISR,JPN,JOR,KAZ,KHM,KOR,KWT,KGZ,LAO,LBN,MYS,MDV,MNG,MMR,NPL,OMN,PAK,PRK,PSE,PHL,QAT,RUS,SAU,SGP,LKA,SYR,TWN,TJK,THA,TLS,TUR,TKM,UZB,VNM,YEM,AIA,ATG,ARG,ABW,BHS,BRB,BLZ,BOL,BES,BVT,BRA,CYM,CHL,COL,CRI,CUB,CUW,DMA,DOM,ECU,SLV,FLK,GUF,GRD,GLP,GTM,GUY,HTI,HND,JAM,MTQ,MEX,MSR,NIC,PAN,PRY,PER,PRI,BLM,KNA,LCA,MAF,VCT,SXM,SGS,SUR,TTO,TCA,URY,VEN,VGB,VIR,ASM,AUS,COK,FJI,PYF,KIR,MHL,FSM,NRU,NCL,NZL,NIU,NFK,MNP,PLW,PNG,PCN,WSM,SLB,TKL,TON,TUV,VUT,WLF'
)
continentCountryMap.set(
  'AS-AF',
  'ARE,BHR,EGY,IRN,IRQ,ISR,JOR,KWT,LBN,LBY,OMN,PSE,QAT,SAU,SYR,TUR,YEM,AGO,BDI,BEN,BFA,BWA,CAF,CIV,CMR,COD,COG,COM,CPV,DJI,DZA,EGY,ERI,ESH,ETH,GAB,GHA,GIN,GMB,GNB,GNQ,KEN,LBR,LBY,LSO,MAR,MDG,MLI,MOZ,MRT,MUS,MWI,MYT,NAM,NER,NGA,REU,RWA,SDN,SEN,SHN,SLE,SOM,SSD,STP,SWZ,SYC,TCD,TGO,TUN,TZA,UGA,ZAF,ZMB,ZWE,ATA'
)
